/** @prettier */

/**
 * 消費電力グラフの共通設定
 * @param props props
 * @returns 共通設定
 */

import {TFunction} from 'i18next';
import {GraphDataRange} from '../../../../Type/TypeDef';

export const barGraphBasicSetting = (props: {
  xLabel: ApexXAxis['categories']; //X軸のラベル
  dateRange: GraphDataRange; //データ取得範囲
  csvFileNameDate: string; //CSVファイルの名前（日付部分）
  csvFileNameTarget: string; //CSVファイルの名前（サイトの名前 + グラフの対象の名前）
  trans: TFunction; //翻訳関数
}): ApexCharts.ApexOptions => {
  const csvFileName = `P_${props.csvFileNameDate}_${props.csvFileNameTarget}`;

  /** X軸に表示するタイトル */
  const xAxisTitle = (dateRange: GraphDataRange) => {
    //データ取得範囲によってタイトルを切り替える
    switch (dateRange) {
      //データ取得範囲が1日の場合
      case 'day':
      default:
        return props.trans('barGraphBasicSetting.xAxisTitle.time');
      //データ取得範囲が1週間、または1カ月の場合
      case 'week':
      case 'month':
        return props.trans('barGraphBasicSetting.xAxisTitle.day');
      //データ取得範囲が1年の場合
      case 'year':
        return props.trans('barGraphBasicSetting.xAxisTitle.month');
      //データ取得範囲が10年の場合
      case 'tenYear':
        return props.trans('barGraphBasicSetting.xAxisTitle.year');
    }
  };
  /**  Y軸の基本設定*/
  const yAxisOptions: ApexYAxis = {
    title: {
      text: `${props.trans('barGraphBasicSetting.yAxisTitle')}`,
      style: {fontFamily: 'DINNextLTPro-Bold'},
    },
    labels: {
      style: {fontFamily: 'DINNextLTPro-Regular'},
      formatter: (value: number) => {
        //　小数点はカンマ表示。フランス式にする
        return value.toLocaleString('fr-FR');
      },
    },
  };

  return {
    chart: {
      type: 'bar',
      locales: [
        {
          name: 'en',
          options: {
            toolbar: {
              selectionZoom: `${props.trans(
                'barGraphBasicSetting.graphToolbar.selectionZoom'
              )}`,
              zoomIn: `${props.trans(
                'barGraphBasicSetting.graphToolbar.zoomIn'
              )}`,
              zoomOut: `${props.trans(
                'barGraphBasicSetting.graphToolbar.zoomOut'
              )}`,
              reset: `${props.trans(
                'barGraphBasicSetting.graphToolbar.reset'
              )}`,
              exportToSVG: `${props.trans(
                'barGraphBasicSetting.graphToolbar.exportToSVG'
              )}`,
              exportToPNG: `${props.trans(
                'barGraphBasicSetting.graphToolbar.exportToPNG'
              )}`,
              exportToCSV: `${props.trans(
                'barGraphBasicSetting.graphToolbar.exportToCSV'
              )}`,
            },
          },
        },
      ],
      stacked: true,
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: false,
          reset: true,
          customIcons: [],
        },
        export: {
          csv: {
            filename: csvFileName,
            columnDelimiter: ',',
            headerCategory: 'Time',
            headerValue: 'value',
            dateFormatter: timestamp => {
              if (timestamp !== undefined) {
                return new Date(timestamp).toDateString();
              }
            },
          },
          svg: {
            filename: csvFileName,
          },
          png: {
            filename: csvFileName,
          },
        },
      },
      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 1,
    },
    plotOptions: {
      bar: {
        dataLabels: {
          position: 'center',
        },
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    xaxis: {
      title: {
        text: xAxisTitle(props.dateRange),
        style: {fontFamily: 'DINNextLTPro-Bold'},
      },
      categories: props.xLabel,
      tickPlacement: 'on',
      tickAmount: 56,
      labels: {
        hideOverlappingLabels: true,
        style: {fontFamily: 'DINNextLTPro-Regular'},
      },
      tooltip: {style: {fontFamily: 'DINNextLTPro-Regular'}},
    },
    yaxis: yAxisOptions,
    legend: {
      position: 'right',
      fontFamily: 'DINNextLTPro-Regular',
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      style: {fontFamily: 'DINNextLTPro-Regular'},
      y: {
        formatter: function (value) {
          return value + 'kWh';
        },
      },
    },
  };
};
